import { t } from 'i18next';

export const getProfileSettingsTitle = (title: string) => {
  switch (title) {
    case 'profile':
      return t('S025');
    case 'password':
      return t('S026');
    case 'passcode':
      return t('S028');
    case 'languages':
      return t('PL001');
    case 'streaks':
      return t('S043');
    case 'stats':
      return t('S047');
    default:
      return '';
  }
};
